/**
* DO NOT EDIT THIS FILE
*/
import { RoomPeople } from '../module/yanolja_standardcode/room-people'
import { CancelBadgeTypes } from '../module/yanolja_standardcode_accommodation/cancel-badge-types'
import { GlobalStayProductOptions } from '../module/yanolja_clientlog_custom_order/global-stay-product-options'
import { DiscountSelectionType } from '../module/yanolja_standardcode/discount-selection-type'
import { GlobalStayDiscountInfo } from '../module/yanolja_clientlog_custom_order/global-stay-discount-info'
import { CouponSelectionOptions } from '../module/yanolja_clientlog_custom_order/coupon-selection-options'
import { GlobalOrderStatus } from '../module/yanolja_clientlog_custom_order/global-order-status'
import { CartOrderAppliedCoupons } from '../module/yanolja_clientlog_custom_order/cart-order-applied-coupons'
import { WarrantyPolicyResultCode } from '../module/yanolja_commerce_order_global_domain/warranty-policy-result-code'
import { OrderTermsType } from '../module/yanolja_standardcode/order-terms-type'
import { GlobalOrderPurpose } from '../module/yanolja_clientlog_custom_order/global-order-purpose'
import { YN } from '../module/yanolja_clientlog_custom_order/yn'
import { GOrderDetailBenefitBadge } from '../module/yanolja_clientlog_custom_order/g-order-detail-benefit-badge'
import { GOrderDetailPageClickName } from '../module/yanolja_clientlog_custom_order/g-order-detail-page-click-name'
import { GOrderDetailFreeCancelSheetClickName } from '../module/yanolja_clientlog_custom_order/g-order-detail-free-cancel-sheet-click-name'
import { GOrderDetailReservationConfirmClickName } from '../module/yanolja_clientlog_custom_order/g-order-detail-reservation-confirm-click-name'
import { GOrderListStatus } from '../module/yanolja_clientlog_custom_order/g-order-list-status'
import { GOrderListOtherClicks } from '../module/yanolja_clientlog_custom_order/g-order-list-other-clicks'
import { CashReceiptType } from '../module/yanolja_clientlog_custom_order/cash-receipt-type'
import { CashReceiptOption } from '../module/yanolja_clientlog_custom_order/cash-receipt-option'
import { CashReceiptInputEventType } from '../module/yanolja_clientlog_custom_order/cash-receipt-input-event-type'
import { KinesisTracker } from '@yanolja-rnd/ya-tracker';






/**
* PageName: GLOBAL_ORDER    */
export const GlobalOrderPageLog = {
  GlobalStayOrderView: {
    /**
        * 주문 페이지(Order) - View - Page
        * 구 로그번호 : 67
# 결제수단 선택
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L9}
        * GlobalStayOrderView
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L420}
        */
    view({
      checkInDate,
      checkOutDate,
      roomPeople,
      propertyId,
      roomTypeId,
      ratePlanId,
      availableCouponCount,
      price,
      priceType,
      badgeMemberCode,
      cancelBadgeType,
    }: GlobalOrderPageLog.GlobalStayOrderView.View) {
      return KinesisTracker.view('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1711,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        eventType: 'EVENT_TYPE_VIEW',
        checkInDate,
        checkOutDate,
        roomPeople,
        propertyId,
        roomTypeId,
        ratePlanId,
        availableCouponCount,
        price,
        priceType,
        badgeMemberCode,
        cancelBadgeType,
      })
    },
  },

  PaymentButtonMethod: {
    /**
     * 주문 페이지(Order) - 클릭 - 결제수단 선택 - 버튼
     * # 주문실패 팝업
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L23}
     * GlobalStayOrderPaymentMethod
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L289}
     */
    click({ nolCard, paymentMethod }: GlobalOrderPageLog.PaymentButtonMethod.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1712,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'paymentMethod',
        objectContainer: 'payment',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        nolCard,
        paymentMethod,
      })
    },
  },

  PopupOrderFailed: {
    /**
     * 주문 페이지(Order) - 노출 - 주문 실패 - 팝업
     * # 헤더
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L41}
     * GlobalStayOrderPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L296}
     */
    impression({ popupTitle }: GlobalOrderPageLog.PopupOrderFailed.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1713,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'orderFailedPopup',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        popupTitle,
      })
    },
  },

  ButtonBackward: {
    /**
     * 주문 페이지(Order) - 클릭 - 뒤로가기 - 버튼
     * app only
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L58}
     */
    click({}: GlobalOrderPageLog.ButtonBackward.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1714,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'backward',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  HeaderTextLogin: {
    /**
     * 주문 페이지(Order) - 클릭 - 상단 로그인 하기 - 텍스트
     * app only
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L72}
     */
    click({}: GlobalOrderPageLog.HeaderTextLogin.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1715,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'login',
        objectContainer: 'header',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  ButtonLogin: {
    /**
        * 주문 페이지(Order) - 클릭 - 로그인후 할인혜택 - 버튼
        * 구 로그번호 : 없음(object = loginBtn)
# 이용자 정보
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L87}
                    */
    click({}: GlobalOrderPageLog.ButtonLogin.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1716,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'login',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  TextChangePhone: {
    /**
     * 주문 페이지(Order) - 클릭 - 회원 계정관리 - 텍스트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L102}
     */
    click({}: GlobalOrderPageLog.TextChangePhone.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1717,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'changePhone',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  ButtonVerifyIdentity: {
    /**
     * 주문 페이지(Order) - 클릭 - 휴대폰 번호 인증하기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L116}
     */
    click({}: GlobalOrderPageLog.ButtonVerifyIdentity.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1718,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'verifyIdentity',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  CompletedVerifyIdentity: {
    /**
     * 주문 페이지(Order) - BG - 본인인증 완료시
     * # 할인
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L130}
     */
    bg({}: GlobalOrderPageLog.CompletedVerifyIdentity.Bg = {}) {
      return KinesisTracker.bg('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1719,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'completedVerifyIdentity',
        eventType: 'EVENT_TYPE_BG',
      })
    },
  },

  DiscountSectionButton: {
    /**
     * 주문 페이지(Order)(Order) - 할인영역 - 클릭 - 쿠폰할인 - 버튼
     * 구 로그번호 : 없음(object = discountBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L144}
     * GlobalStayOrderDiscountButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L301}
     */
    click({ productOptions, couponBoxTitle }: GlobalOrderPageLog.DiscountSectionButton.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1720,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'discount',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        couponBoxTitle,
      })
    },
  },

  DiscountSectionCheckboxMax: {
    /**
     * 주문 페이지(Order) - 클릭 - 최대할인적용 - 체크박스
     * 구 로그번호 : 없음(object = maxDiscountBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L161}
     * GlobalStayOrderCheckBox
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L307}
     */
    click({
      productOptions,
      checkYn,
      clickName,
      imprName,
    }: GlobalOrderPageLog.DiscountSectionCheckboxMax.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1721,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'maxDiscount',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        checkYn,
        clickName,
        imprName,
      })
    },
  },

  DiscountSelectionRadioClickName: {
    /**
     * 주문 페이지(Order) - 할인선택 풀스크린 다이아로그 - 클릭 - 라디오버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L178}
     * GlobalStayOrderDiscountSelectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L325}
     */
    click({
      productOptions,
      clickName,
      orderDiscounts,
    }: GlobalOrderPageLog.DiscountSelectionRadioClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1722,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_RADIO',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        clickName,
        orderDiscounts,
      })
    },
  },

  DiscountSelectionCheckboxMax: {
    /**
     * 주문 페이지(Order) - 할인선택 풀스크린 다이아로그 - 클릭 - 최대할인적용 - 체크박스
     * 구 로그번호 : 103
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L195}
     * GlobalStayOrderMaxDiscountCheck
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L384}
     */
    click({ checkYn }: GlobalOrderPageLog.DiscountSelectionCheckboxMax.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1723,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'maxDiscount',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
      })
    },
  },

  DiscountSelectionButtonClose: {
    /**
     * 주문 페이지(Order) - 할인선택 풀스크린 다이아로그 - 클릭 - 닫기 - 버튼
     * 구 로그번호 : 105
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L212}
     * GlobalStayDiscountSelection
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L337}
     */
    click({
      productOptions,
      orderDiscounts,
    }: GlobalOrderPageLog.DiscountSelectionButtonClose.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1725,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'close',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        orderDiscounts,
      })
    },
  },

  DiscountSelectionButtonApply: {
    /**
     * 주문 페이지(Order) - 할인선택 풀스크린 다이아로그 - 클릭 - 할인적용하기 - 버튼
     * 구 로그번호 : 106
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L229}
     * GlobalStayDiscountSelection
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L337}
     */
    click({
      productOptions,
      orderDiscounts,
    }: GlobalOrderPageLog.DiscountSelectionButtonApply.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1726,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'discountApply',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        orderDiscounts,
      })
    },
  },

  BottomSheetCouponSelection: {
    /**
     * 주문 페이지(Order) - 할인쿠폰 선택 바텀시트 - 노출
     * 구 로그번호 : 107
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L246}
     * GlobalOrderCouponSelection
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L342}
     */
    impression({
      couponOptions,
      clickName,
    }: GlobalOrderPageLog.BottomSheetCouponSelection.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1727,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'couponSelection',
        objectContainer: 'couponSelection',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        couponOptions,
        clickName,
      })
    },
  },

  CouponSelectionButtonClickName: {
    /**
     * 주문 페이지(Order) - 할인쿠폰 선택 바텀시트 - 클릭 - 적용안함/쿠폰종류 - 버튼
     * 구 로그번호 : 109,110
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L263}
     * GlobalOrderCouponSelection
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L342}
     */
    click({ couponOptions, clickName }: GlobalOrderPageLog.CouponSelectionButtonClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1728,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'couponSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        couponOptions,
        clickName,
      })
    },
  },

  CouponSelectionButtonApply: {
    /**
     * 주문 페이지(Order) - 할인쿠폰 선택 바텀시트 - 클릭 - 적용하기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L280}
     * GlobalOrderCouponSelection
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L342}
     */
    click({ couponOptions, clickName }: GlobalOrderPageLog.CouponSelectionButtonApply.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1729,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'couponApply',
        objectContainer: 'couponSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        couponOptions,
        clickName,
      })
    },
  },

  ButtonPayment: {
    /**
     * 주문 페이지(Order) - 클릭 - 결제하기 - 버튼
     * 구 로그번호 : 424
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L297}
     * GlobalStayOrderPayment
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L289}
     */
    click({
      productOptions,
      pgType,
      orderAmount,
      pointAmount,
      packageDiscountAmount,
      pgAmount,
      couponAmount,
      nolPointAmount,
      isMaxDiscountApplied,
      isSameAsBooker,
    }: GlobalOrderPageLog.ButtonPayment.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1730,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'payment',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        pgType,
        orderAmount,
        pointAmount,
        packageDiscountAmount,
        pgAmount,
        couponAmount,
        nolPointAmount,
        isMaxDiscountApplied,
        isSameAsBooker,
      })
    },
  },

  BenefitInfoTextType: {
    /**
     * 주문 페이지(Order) - 혜택정보 - 노출 - 혜택 - 텍스트
     * 구 로그번호 : 421
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L313}
     * GlobalStayOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L374}
     */
    impression({
      benefitType,
      benefitSubType,
      status,
    }: GlobalOrderPageLog.BenefitInfoTextType.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1731,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_IMPR',
        benefitType,
        benefitSubType,
        status,
      })
    },

    /**
     * 주문 페이지(Order) - 혜택정보 - 클릭 - 혜택 - 텍스트
     * 구 로그번호 : 422
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L330}
     * GlobalStayOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L374}
     */
    click({ benefitType, benefitSubType, status }: GlobalOrderPageLog.BenefitInfoTextType.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1732,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
        benefitType,
        benefitSubType,
        status,
      })
    },
  },

  DiscountSectionTextBenefitType: {
    /**
        * 주문 페이지(Order) - 할인영역 - 노출 - 혜택(NOL카드) - 텍스트
        * NOL카드 미발급자에 한해 노출
구 로그번호 : 없음(object = nolCoupon)
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L347}
        * GlobalStayOrderBenefitInfo
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L374}
        */
    impression({
      benefitType,
      benefitSubType,
      status,
    }: GlobalOrderPageLog.DiscountSectionTextBenefitType.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1733,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'benefitType',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_IMPR',
        benefitType,
        benefitSubType,
        status,
      })
    },

    /**
     * 주문 페이지(Order) - 할인영역 - 클릭 - 혜택(NOL카드) - 텍스트
     * 구 로그번호 : 없음(object = nolCoupon)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L365}
     * GlobalStayOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L374}
     */
    click({
      benefitType,
      benefitSubType,
      status,
    }: GlobalOrderPageLog.DiscountSectionTextBenefitType.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1734,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'benefitType',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
        benefitType,
        benefitSubType,
        status,
      })
    },
  },

  ProductInfoButtonFreeCancel: {
    /**
     * 주문 페이지(Order) - 상품정보 - 클릭 - 취소규정(배너) - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L381}
     * GlobalStayProductOptions
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L246}
     */
    click({
      propertyId,
      roomTypeId,
      ratePlanId,
      supplierName,
      priceType,
      badgeMemberCode,
      price,
      checkInDate,
      checkOutDate,
      checkInTime,
      checkOutTime,
      discount,
      promotionBadges,
      optionBadges,
      occupancyInfo,
      cancelType,
      roomPeople,
    }: GlobalOrderPageLog.ProductInfoButtonFreeCancel.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1735,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'productFreeCancelInfo',
        objectContainer: 'productInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        propertyId,
        roomTypeId,
        ratePlanId,
        supplierName,
        priceType,
        badgeMemberCode,
        price,
        checkInDate,
        checkOutDate,
        checkInTime,
        checkOutTime,
        discount,
        promotionBadges,
        optionBadges,
        occupancyInfo,
        cancelType,
        roomPeople,
      })
    },
  },

  BottomSheetReservationConfirm: {
    /**
     * 주문 페이지(Order) - 노출 - 결제 전 예약정보 확인 바텀시트 - 바텀싯
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L398}
     * GlobalStayProductOptions
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L246}
     */
    impression({
      propertyId,
      roomTypeId,
      ratePlanId,
      supplierName,
      priceType,
      badgeMemberCode,
      price,
      checkInDate,
      checkOutDate,
      checkInTime,
      checkOutTime,
      discount,
      promotionBadges,
      optionBadges,
      occupancyInfo,
      cancelType,
      roomPeople,
    }: GlobalOrderPageLog.BottomSheetReservationConfirm.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1736,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'reservationConfirm',
        objectContainer: 'reservationConfirm',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        propertyId,
        roomTypeId,
        ratePlanId,
        supplierName,
        priceType,
        badgeMemberCode,
        price,
        checkInDate,
        checkOutDate,
        checkInTime,
        checkOutTime,
        discount,
        promotionBadges,
        optionBadges,
        occupancyInfo,
        cancelType,
        roomPeople,
      })
    },
  },

  ReservationConfirmButtonClickName: {
    /**
     * 주문 페이지(Order) - 클릭 - 결제 전 예약정보 확인 바텀시트 - 버튼
     * # 특별 요청 사항
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L414}
     * GlobalStayOrderReservationClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L389}
     */
    click({
      productOptions,
      clickName,
    }: GlobalOrderPageLog.ReservationConfirmButtonClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1737,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'reservationConfirm',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        clickName,
      })
    },
  },

  AdditionalRequestSelectBoxImprName: {
    /**
     * 주문 페이지(Order) - 노출 - 특별요청사항(숙소 도착 예정 시간) - 셀렉트박스
     * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L431}
     * GlobalStayOrderOptionImprClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L396}
     */
    impression({
      productOptions,
      imprName,
      clickName,
    }: GlobalOrderPageLog.AdditionalRequestSelectBoxImprName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1738,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'imprName',
        objectContainer: 'additionalRequest',
        objectType: 'OBJECT_TYPE_SELECT_BOX',
        eventType: 'EVENT_TYPE_IMPR',
        productOptions,
        imprName,
        clickName,
      })
    },
  },

  AdditionalRequestSelectBoxClickName: {
    /**
     * 주문 페이지(Order) - 클릭 - 특별요청사항(숙소 도착 예정 시간) - 셀렉트박스
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L447}
     * GlobalStayOrderOptionImprClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L396}
     */
    click({
      productOptions,
      imprName,
      clickName,
    }: GlobalOrderPageLog.AdditionalRequestSelectBoxClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1739,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'additionalRequest',
        objectType: 'OBJECT_TYPE_SELECT_BOX',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        imprName,
        clickName,
      })
    },
  },

  AdditionalRequestCheckboxImprName: {
    /**
     * 주문 페이지(Order) - 노출 - 특별요청사항(기타 요청 사항) - 체크박스
     * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L463}
     * GlobalStayOrderCheckBox
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L307}
     */
    impression({
      productOptions,
      checkYn,
      clickName,
      imprName,
    }: GlobalOrderPageLog.AdditionalRequestCheckboxImprName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1740,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'imprName',
        objectContainer: 'additionalRequest',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_IMPR',
        productOptions,
        checkYn,
        clickName,
        imprName,
      })
    },
  },

  AdditionalRequestCheckboxClickName: {
    /**
     * 주문 페이지(Order) - 클릭 - 특별요청사항(기타 요청 사항) - 체크박스
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L479}
     * GlobalStayOrderCheckBox
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L307}
     */
    click({
      productOptions,
      checkYn,
      clickName,
      imprName,
    }: GlobalOrderPageLog.AdditionalRequestCheckboxClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1741,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'additionalRequest',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        checkYn,
        clickName,
        imprName,
      })
    },
  },

  AdditionalRequestTextFieldImprName: {
    /**
        * 주문 페이지(Order) - 노출 - 특별요청사항(요청 사항 직접 입력) - 텍스트필드
        * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
# 침대 유형
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L495}
        * GlobalStayOrderOptionImprClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L396}
        */
    impression({
      productOptions,
      imprName,
      clickName,
    }: GlobalOrderPageLog.AdditionalRequestTextFieldImprName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1742,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'imprName',
        objectContainer: 'additionalRequest',
        objectType: 'OBJECT_TYPE_TEXT_FIELD',
        eventType: 'EVENT_TYPE_IMPR',
        productOptions,
        imprName,
        clickName,
      })
    },
  },

  BedTypeRadioImprName: {
    /**
     * 주문 페이지(Order) - 노출 - 침대 유형 - 라디오버튼
     * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L512}
     * GlobalStayOrderOptionImprClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L396}
     */
    impression({
      productOptions,
      imprName,
      clickName,
    }: GlobalOrderPageLog.BedTypeRadioImprName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1743,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'imprName',
        objectContainer: 'bedType',
        objectType: 'OBJECT_TYPE_RADIO',
        eventType: 'EVENT_TYPE_IMPR',
        productOptions,
        imprName,
        clickName,
      })
    },
  },

  BedTypeRadioClickName: {
    /**
        * 주문 페이지(Order) - 노출 - 침대 유형 - 라디오버튼
        * ################################ [END] 주문화면 CX 개선 로그 #################################
################################ [START] 주문화면 CX 개선 이전(레거시) 로그 #################################
################# 100% 전환 이후에도 inactive 하지 않는 로그 ##################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L528}
        * GlobalStayOrderOptionImprClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L396}
        */
    impression({
      productOptions,
      imprName,
      clickName,
    }: GlobalOrderPageLog.BedTypeRadioClickName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1744,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'bedType',
        objectType: 'OBJECT_TYPE_RADIO',
        eventType: 'EVENT_TYPE_IMPR',
        productOptions,
        imprName,
        clickName,
      })
    },
  },

  PointTypeCheckboxSave: {
    /**
     * 주문 페이지(Order) - 노출 - 포인트 적립 - 체크박스
     * cartOrder 로그번호 : 470
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L549}
     * GOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L203}
     */
    impression({
      hashOrderId,
      checkYn,
      clickName,
      pointType,
    }: GlobalOrderPageLog.PointTypeCheckboxSave.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        clientEventId: 473,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'savePoint',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  PointTypeCheckboxCheckYn: {
    /**
     * 주문 페이지(Order) - 클릭 - 포인트 적립 - 체크박스
     * cartOrder 로그번호 : 471
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L564}
     * GOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L203}
     */
    click({
      hashOrderId,
      checkYn,
      clickName,
      pointType,
    }: GlobalOrderPageLog.PointTypeCheckboxCheckYn.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 474,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'checkYn',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  PointTypeButtonClickName: {
    /**
     * 주문 페이지(Order) - 클릭 - 포인트 관련(eg. 전액사용, X(삭제하기), 연동하기 등) - 버튼
     * cartOrder 로그번호 : 472
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L579}
     * GOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L203}
     */
    click({
      hashOrderId,
      checkYn,
      clickName,
      pointType,
    }: GlobalOrderPageLog.PointTypeButtonClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 475,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  FreeCancelBoxCard: {
    /**
        * 주문창 - 캔슬프리 카드 노출
        * 스크린샷: https://screen.yanolja.in/DorAhThYFoXYTKwU.png
해당 로그는 주문창 진입시점 내 최초 1회만 로그를 남김.
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L594}
        * GlobalOrderFreeCancel
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
        */
    impression({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderPageLog.FreeCancelBoxCard.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        clientEventId: 68,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'freeCancelCard',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxCheckboxBtn: {
    /**
     * 주문창 - 캔슬프리 체크박스 클릭
     * 스크린샷: https://screen.yanolja.in/DorAhThYFoXYTKwU.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L609}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderPageLog.FreeCancelBoxCheckboxBtn.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 69,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'freeCancelBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxButtonDetailBtn: {
    /**
     * 주문창 - 캔슬프리 상세보기 클릭
     * 스크린샷: https://screen.yanolja.in/DorAhThYFoXYTKwU.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L624}
     */
    click({}: GlobalOrderPageLog.FreeCancelBoxButtonDetailBtn.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 70,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'freeCancelDetailBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  PopupFreeCancelLoginPopUp: {
    /**
     * 주문창 - 캔슬프리 로그인 팝업 노출
     * 스크린샷: https://screen.yanolja.in/pjcy7rQAcVjEPs4p.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L637}
     */
    impression({}: GlobalOrderPageLog.PopupFreeCancelLoginPopUp.Impression = {}) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        clientEventId: 71,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'freeCancelLoginPopUp',
        objectContainer: 'freeCancelLoginPopUp',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
      })
    },
  },

  FreeCancelLoginPopUpButtonBtn: {
    /**
     * 주문창 - 캔슬프리 로그인 팝업 내 버튼 클릭
     * 스크린샷: https://screen.yanolja.in/pjcy7rQAcVjEPs4p.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L650}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderPageLog.FreeCancelLoginPopUpButtonBtn.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 72,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'freeCancelLoginPopUpBtn',
        objectContainer: 'freeCancelLoginPopUp',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FloatingButtonFreeCancelNudgeBtn: {
    /**
     * 주문창 - 캔슬프리 넛징 버튼 클릭
     * 스크린샷: https://screen.yanolja.in/Dox0MK0ApIKIrm6i
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L665}
     */
    click({}: GlobalOrderPageLog.FloatingButtonFreeCancelNudgeBtn.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 73,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'freeCancelNudgeBtn',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  TermsSectionCheckboxClickName: {
    /**
        * (해외숙소)주문 - 클릭 - 약관동의 체크박스
        * ################# 100% 전환 이후 inactive 하는 로그 ##################
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L677}
        * GlobalStayOrderTermsClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L448}
        */
    click({
      isLogin,
      clickName,
      isChecked,
    }: GlobalOrderPageLog.TermsSectionCheckboxClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 2138,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'termsSection',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        isLogin,
        clickName,
        isChecked,
      })
    },
  },

  GlobalOrderView: {
    /**
        * 주문창 - view 로그
        * TODO: 주문창 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
################################ [END] 주문화면 CX 개선 이전(레거시) 로그 #################################
####################################################################################################
################################ [END] 주문창(GlobalOrder) 로그 #######################################
####################################################################################################
######################################################################################################
############################# [START] 주문완료/취소(GlobalOrderStatus) ##################################
######################################################################################################
################################ [START] 주문화면 CX 개선 로그 #################################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L693}
        * GlobalOrderView
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L57}
        */
    view({
      checkInDate,
      checkOutDate,
      roomPeople,
      propertyId,
      roomTypeId,
      ratePlanId,
      availableCouponCount,
      totalPrice,
      priceType,
      globalStayPriceMemberCode,
      cancelBadgeType,
    }: GlobalOrderPageLog.GlobalOrderView.View) {
      return KinesisTracker.view('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 67,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        eventType: 'EVENT_TYPE_VIEW',
        checkInDate,
        checkOutDate,
        roomPeople,
        propertyId,
        roomTypeId,
        ratePlanId,
        availableCouponCount,
        totalPrice,
        priceType,
        globalStayPriceMemberCode,
        cancelBadgeType,
      })
    },
  },

  PaymentNolMoneyButtonClickName: {
    /**
     * ORDER(해외숙소) - 결제수단 NOL머니 관련 버튼 - 클릭
     * 스크린샷 : https://screen.yanolja.in/HiNEfONERvx1KEhA
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1527}
     * GOrderNolMoneyClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L210}
     */
    click({
      clickName,
      nolmoneyRegisterYn,
      accountRegistrationYn,
    }: GlobalOrderPageLog.PaymentNolMoneyButtonClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 637,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'paymentNolMoney',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        clickName,
        nolmoneyRegisterYn,
        accountRegistrationYn,
      })
    },
  },

  PaymentNolMoneyPopupButtonClickName: {
    /**
     * ORDER(해외숙소) - 결제하기 버튼 클릭 후 NOL머니 계좌 연결 팝업 - 클릭
     * 스크린샷 : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1540}
     * GOrderNolMoneyPopupClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L217}
     */
    click({
      clickName,
      nolmoneyRegisterYn,
      accountRegistrationYn,
    }: GlobalOrderPageLog.PaymentNolMoneyPopupButtonClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 638,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'paymentNolMoneyPopup',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        clickName,
        nolmoneyRegisterYn,
        accountRegistrationYn,
      })
    },
  },

  NolMoneyCertifyBottomSheetButton: {
    /**
     * ORDER(해외숙소) - NOL머니 본인 인증하기 bottomsheet - 클릭
     * 화면 : https://screen.yanolja.in/NLsGOJuXf3Kr7lZH
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1553}
     */
    click({}: GlobalOrderPageLog.NolMoneyCertifyBottomSheetButton.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        clientEventId: 639,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'nolMoneyCertify',
        objectContainer: 'nolMoneyCertifyBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  SectionNameButtonClick: {
    /**
     * 모웹 - (해외숙소)주문서 - NOL머니 계좌등록 및 결제시도 -  앱 이동 bottomsheet - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1566}
     * NolMoneySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L117}
     */
    click({ pageTitle, sectionName, clickName }: GlobalOrderPageLog.SectionNameButtonClick.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 723,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        sectionName,
        clickName,
      })
    },
  },

  BottomSheetSectionName: {
    /**
     * 모웹 - (해외숙소)주문서 - NOL머니 계좌등록 및 결제시도 -  앱 이동 bottomsheet - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1579}
     * NolMoneySectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L109}
     */
    impression({ pageTitle, sectionName }: GlobalOrderPageLog.BottomSheetSectionName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 724,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        sectionName,
      })
    },
  },

  SectionNamePopupClick: {
    /**
     * PC - (해외숙소)주문서 - NOL머니 계좌등록 및 결제시도 -  앱사용 팝업 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1592}
     * NolMoneySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L117}
     */
    click({ pageTitle, sectionName, clickName }: GlobalOrderPageLog.SectionNamePopupClick.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 725,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        sectionName,
        clickName,
      })
    },
  },

  PopupSectionName: {
    /**
     * PC - (해외숙소)주문서 - NOL머니 계좌등록 및 결제시도 -  앱사용 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1605}
     * NolMoneySectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L109}
     */
    impression({ pageTitle, sectionName }: GlobalOrderPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 726,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        sectionName,
      })
    },
  },

  BottomSheetSectionName1137: {
    /**
     * 주문서 - NOL머니 새로/이어서 등록하기 -  노출 - 바텀시트
     * NOL머니 계좌등록 이후 확인 가능
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1619}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L180}
     */
    impression({ sectionName }: GlobalOrderPageLog.BottomSheetSectionName1137.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1137,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
      })
    },
  },

  SectionNameButtonClick1138: {
    /**
     * 주문서 - NOL머니 새로/이어서 등록하기 -  클릭 - 바텀시트
     * NOL머니 계좌등록 이후 확인 가능
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1633}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L187}
     */
    click({ sectionName, clickName }: GlobalOrderPageLog.SectionNameButtonClick1138.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 1138,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
      })
    },
  },

  PopupSectionName747: {
    /**
     * (해외숙소)주문 - 3분 이내 동일결제금액 confirm 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1674}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L180}
     */
    impression({ sectionName }: GlobalOrderPageLog.PopupSectionName747.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 747,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
      })
    },
  },

  SectionNamePopupClick748: {
    /**
     * (해외숙소)주문 - 3분 이내 동일결제금액 confirm 팝업 - 클릭
     * ######################### 현금 영수증 로그 ##########################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1687}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L187}
     */
    click({ sectionName, clickName }: GlobalOrderPageLog.SectionNamePopupClick748.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 748,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
      })
    },
  },

  WidgetCashReceipt: {
    /**
     * (해외숙소)주문 - 현금 영수증 영역 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1701}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L306}
     */
    impression({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: GlobalOrderPageLog.WidgetCashReceipt.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 863,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'cashReceipt',
        objectType: 'OBJECT_TYPE_WIDGET',
        eventType: 'EVENT_TYPE_IMPR',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptCheckbox: {
    /**
     * (해외숙소)주문 - 현금 영수증 신청하기 체크박스 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1713}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L306}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: GlobalOrderPageLog.CashReceiptCheckbox.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 864,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'cashReceiptCheckbox',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptRadioType: {
    /**
     * (해외숙소)주문 - 현금 영수증 라디오 버튼 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1726}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L306}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: GlobalOrderPageLog.CashReceiptRadioType.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 865,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'cashReceiptType',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_RADIO',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptDropdownFilter: {
    /**
     * (해외숙소)주문 - 현금 영수증 드롭다운 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1739}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L306}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: GlobalOrderPageLog.CashReceiptDropdownFilter.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 866,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'cashReceiptDropdown',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_DROPDOWN_FILTER',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptTextFieldInput: {
    /**
     * (해외숙소)주문 - 현금 영수증 입력 박스 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1752}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L306}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: GlobalOrderPageLog.CashReceiptTextFieldInput.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 867,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'cashReceiptInput',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_TEXT_FIELD',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptSelectModalBottomSheetOptionName: {
    /**
     * (해외숙소)주문 - 현금 영수증 신청 선택 모달 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1765}
     * OrderCashReceiptSelectModalClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L314}
     */
    click({ optionName }: GlobalOrderPageLog.CashReceiptSelectModalBottomSheetOptionName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER', {
        inactive: false,
        clientEventId: 868,
        pageName: 'PAGE_NAME_GLOBAL_ORDER',
        object: 'optionName',
        objectContainer: 'cashReceiptSelectModal',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_CLICK',
        optionName,
      })
    },
  },
}

/**
* 자동생성된 로그 전송 타입
*/
export namespace GlobalOrderPageLog {
  export namespace GlobalStayOrderView {
    /**
        * 구 로그번호 : 67
# 결제수단 선택
        */
    export interface View {
      /*체크인 일자.*/
      checkInDate: string
      /*체크아웃 일자.*/
      checkOutDate: string
      /*객실 정보.*/
      roomPeople?: RoomPeople[]
      /*숙소 id.*/
      propertyId: string
      /*객실 id.*/
      roomTypeId: string
      /*ratePlan id.*/
      ratePlanId: string
      /*사용 가능한 쿠폰수*/
      availableCouponCount: number
      /*총 가격.*/
      price: string
      /*객실 요금제 정보.
1. B2C 요금 &gt; B2C
2. B2B 요금 &gt; 회원 등급별로 다른 값(골드 회원 &gt; B2B / 항공구매 회원 &gt; FLIGHT / 골드체험 회원 &gt; B2B_TRAIL)
3. 뱃지 노출 여부 &gt; B2B 요금일 경우 노출되는 사실 활용*/
      priceType: string
      /*회원 등급 정보.*/
      badgeMemberCode: string
      /*취소정책 정보(CANNOT_REFUND-환불 불가/PARTIAL_REFUND-취소수수료 있음/FREE_CANCEL-무료취소)*/
      cancelBadgeType: CancelBadgeTypes
    }
  }
  export namespace PaymentButtonMethod {
    /**
     * # 주문실패 팝업
     */
    export interface Click {
      /*nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /*지급 방법 ex) TOSS*/
      paymentMethod?: string
    }
  }
  export namespace PopupOrderFailed {
    /**
     * # 헤더
     */
    export interface Impression {
      /*팝업시 나타나는 문구.*/
      popupTitle: string
    }
  }
  export namespace ButtonBackward {
    /**
     * app only
     */
    export interface Click {}
  }
  export namespace HeaderTextLogin {
    /**
     * app only
     */
    export interface Click {}
  }
  export namespace ButtonLogin {
    /**
        * 구 로그번호 : 없음(object = loginBtn)
# 이용자 정보
        */
    export interface Click {}
  }
  export namespace TextChangePhone {
    /**
     */
    export interface Click {}
  }
  export namespace ButtonVerifyIdentity {
    /**
     */
    export interface Click {}
  }
  export namespace CompletedVerifyIdentity {
    /**
     * # 할인
     */
    export interface Bg {}
  }
  export namespace DiscountSectionButton {
    /**
     * 구 로그번호 : 없음(object = discountBtn)
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      /*클릭 배너에 표기되는 내용. (e.g -9,999원 쿠폰 할인)*/
      couponBoxTitle: string
    }
  }
  export namespace DiscountSectionCheckboxMax {
    /**
     * 구 로그번호 : 없음(object = maxDiscountBtn)
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      /*체크박스 체크 y, 체크 해제 n : 소문자로 작성*/
      checkYn: string
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      clickName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      imprName?: string
    }
  }
  export namespace DiscountSelectionRadioClickName {
    /**
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      clickName: DiscountSelectionType
      orderDiscounts: GlobalStayDiscountInfo
    }
  }
  export namespace DiscountSelectionCheckboxMax {
    /**
     * 구 로그번호 : 103
     */
    export interface Click {
      /*체크박스 체크 y, 체크 해제 n : 소문자로 작성*/
      checkYn: string
    }
  }
  export namespace DiscountSelectionButtonClose {
    /**
     * 구 로그번호 : 105
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      orderDiscounts: GlobalStayDiscountInfo
    }
  }
  export namespace DiscountSelectionButtonApply {
    /**
     * 구 로그번호 : 106
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      orderDiscounts: GlobalStayDiscountInfo
    }
  }
  export namespace BottomSheetCouponSelection {
    /**
     * 구 로그번호 : 107
     */
    export interface Impression {
      /*노출 : 노출시 전체 쿠폰 리스트 나오도록(노출된 것이 아에 없을 경우 null 처리)
클릭 : 클릭한 쿠폰 정보, 적용안함은 null*/
      couponOptions?: CouponSelectionOptions[]
      /*클릭시 클릭한 버튼에 쓰여진 정보(스크린샷 참고 https://screen.yanolja.in/8KVCgceTvaeCAg5T)*/
      clickName?: string
    }
  }
  export namespace CouponSelectionButtonClickName {
    /**
     * 구 로그번호 : 109,110
     */
    export interface Click {
      /*노출 : 노출시 전체 쿠폰 리스트 나오도록(노출된 것이 아에 없을 경우 null 처리)
클릭 : 클릭한 쿠폰 정보, 적용안함은 null*/
      couponOptions?: CouponSelectionOptions[]
      /*클릭시 클릭한 버튼에 쓰여진 정보(스크린샷 참고 https://screen.yanolja.in/8KVCgceTvaeCAg5T)*/
      clickName?: string
    }
  }
  export namespace CouponSelectionButtonApply {
    /**
     */
    export interface Click {
      /*노출 : 노출시 전체 쿠폰 리스트 나오도록(노출된 것이 아에 없을 경우 null 처리)
클릭 : 클릭한 쿠폰 정보, 적용안함은 null*/
      couponOptions?: CouponSelectionOptions[]
      /*클릭시 클릭한 버튼에 쓰여진 정보(스크린샷 참고 https://screen.yanolja.in/8KVCgceTvaeCAg5T)*/
      clickName?: string
    }
  }
  export namespace ButtonPayment {
    /**
     * 구 로그번호 : 424
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      /*PG결제 유형. 예: &#34;KAKAOPAY&#34;*/
      pgType: string
      /*[결제 금액 및 요약 정보]
총 주문 금액*/
      orderAmount: string
      /*포인트 사용액*/
      pointAmount: string
      /*패키지 할인액*/
      packageDiscountAmount: string
      /*최종 실 결제 금액*/
      pgAmount: string
      /*쿠폰 할인액 합계*/
      couponAmount: string
      /*놀포인트 사용액*/
      nolPointAmount: string
      /*https://screen.yanolja.in/4yXqwxDZiD2DVnET
최대할인적용 체크박스 여부*/
      isMaxDiscountApplied?: boolean
      /*예약자 정보와 같음 체크박스 여부*/
      isSameAsBooker?: boolean
    }
  }
  export namespace BenefitInfoTextType {
    /**
     * 구 로그번호 : 421
     */
    export interface Impression {
      /*https://screen.yanolja.in/saOSE9SnSVT6yezL
ex) nolCard | nolReview*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }

    /**
     * 구 로그번호 : 422
     */
    export interface Click {
      /*https://screen.yanolja.in/saOSE9SnSVT6yezL
ex) nolCard | nolReview*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }
  }
  export namespace DiscountSectionTextBenefitType {
    /**
        * NOL카드 미발급자에 한해 노출
구 로그번호 : 없음(object = nolCoupon)
        */
    export interface Impression {
      /*https://screen.yanolja.in/saOSE9SnSVT6yezL
ex) nolCard | nolReview*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }

    /**
     * 구 로그번호 : 없음(object = nolCoupon)
     */
    export interface Click {
      /*https://screen.yanolja.in/saOSE9SnSVT6yezL
ex) nolCard | nolReview*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }
  }
  export namespace ProductInfoButtonFreeCancel {
    /**
     */
    export interface Click {
      /*숙소 ID.*/
      propertyId: string
      /*룸타입 ID.*/
      roomTypeId: string
      /*레이트플랜 ID.*/
      ratePlanId: string
      /*공급사명.*/
      supplierName: string
      /*숙소 요금제 정보.*/
      priceType: string
      /*회원 등급 정보(구 global_stay_price_member_code). 회원 API 호출과정에서 활용된 회원 등급 정보.*/
      badgeMemberCode: string
      /*총 가격*/
      price: string
      /*현지 체크인 일자. format : yyyy-MM-dd*/
      checkInDate: string
      /*현지 체크아웃 일자. format : yyyy-MM-dd*/
      checkOutDate: string
      /*현지 체크인 시간. format : yyyy-MM-dd HH:mm:dd*/
      checkInTime: string
      /*현지 체크아웃 시간. format : yyyy-MM-dd HH:mm:dd*/
      checkOutTime: string
      /*쿠폰 할인 정보*/
      discount?: CartOrderAppliedCoupons
      /*CX 개선으로 인한 상품 추가정보
뱃지 정보. 예: [&#34;Gold특가&#34;, &#34;숙박페스타&#34;]*/
      promotionBadges?: string[]
      /*레이트플랜 옵션 정보. 예: [&#34;비대면체크인&#34;, &#34;조식포함(2인)&#34;]*/
      optionBadges?: string[]
      /*객실 기본인원 정보. 예: &#34;최대 정원 N명 (아동포함)&#34;*/
      occupancyInfo?: string
      /*주문시점 당시 취소정책 정보. 해외숙소의 경우 필수 수집으로 처리.*/
      cancelType: CancelBadgeTypes
      /*객실 정보.*/
      roomPeople?: RoomPeople[]
    }
  }
  export namespace BottomSheetReservationConfirm {
    /**
     */
    export interface Impression {
      /*숙소 ID.*/
      propertyId: string
      /*룸타입 ID.*/
      roomTypeId: string
      /*레이트플랜 ID.*/
      ratePlanId: string
      /*공급사명.*/
      supplierName: string
      /*숙소 요금제 정보.*/
      priceType: string
      /*회원 등급 정보(구 global_stay_price_member_code). 회원 API 호출과정에서 활용된 회원 등급 정보.*/
      badgeMemberCode: string
      /*총 가격*/
      price: string
      /*현지 체크인 일자. format : yyyy-MM-dd*/
      checkInDate: string
      /*현지 체크아웃 일자. format : yyyy-MM-dd*/
      checkOutDate: string
      /*현지 체크인 시간. format : yyyy-MM-dd HH:mm:dd*/
      checkInTime: string
      /*현지 체크아웃 시간. format : yyyy-MM-dd HH:mm:dd*/
      checkOutTime: string
      /*쿠폰 할인 정보*/
      discount?: CartOrderAppliedCoupons
      /*CX 개선으로 인한 상품 추가정보
뱃지 정보. 예: [&#34;Gold특가&#34;, &#34;숙박페스타&#34;]*/
      promotionBadges?: string[]
      /*레이트플랜 옵션 정보. 예: [&#34;비대면체크인&#34;, &#34;조식포함(2인)&#34;]*/
      optionBadges?: string[]
      /*객실 기본인원 정보. 예: &#34;최대 정원 N명 (아동포함)&#34;*/
      occupancyInfo?: string
      /*주문시점 당시 취소정책 정보. 해외숙소의 경우 필수 수집으로 처리.*/
      cancelType: CancelBadgeTypes
      /*객실 정보.*/
      roomPeople?: RoomPeople[]
    }
  }
  export namespace ReservationConfirmButtonClickName {
    /**
     * # 특별 요청 사항
     */
    export interface Click {
      /*https://screen.yanolja.in/lYFmuA3Nb7vsvNUF*/
      productOptions: GlobalStayProductOptions
      /*버튼에 적힌 문구*/
      clickName: string
    }
  }
  export namespace AdditionalRequestSelectBoxImprName {
    /**
     * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
     */
    export interface Impression {
      productOptions: GlobalStayProductOptions
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      imprName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      clickName?: string
    }
  }
  export namespace AdditionalRequestSelectBoxClickName {
    /**
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      imprName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      clickName?: string
    }
  }
  export namespace AdditionalRequestCheckboxImprName {
    /**
     * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
     */
    export interface Impression {
      productOptions: GlobalStayProductOptions
      /*체크박스 체크 y, 체크 해제 n : 소문자로 작성*/
      checkYn: string
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      clickName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      imprName?: string
    }
  }
  export namespace AdditionalRequestCheckboxClickName {
    /**
     */
    export interface Click {
      productOptions: GlobalStayProductOptions
      /*체크박스 체크 y, 체크 해제 n : 소문자로 작성*/
      checkYn: string
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      clickName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      imprName?: string
    }
  }
  export namespace AdditionalRequestTextFieldImprName {
    /**
        * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
# 침대 유형
        */
    export interface Impression {
      productOptions: GlobalStayProductOptions
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      imprName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      clickName?: string
    }
  }
  export namespace BedTypeRadioImprName {
    /**
     * 첫 노출시만 전송. 클릭하여 노출되는 정보가 달라져도 해당 건에 대해서는 노출로그 미전송(클릭 로그로 확인 가능)
     */
    export interface Impression {
      productOptions: GlobalStayProductOptions
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      imprName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      clickName?: string
    }
  }
  export namespace BedTypeRadioClickName {
    /**
        * ################################ [END] 주문화면 CX 개선 로그 #################################
################################ [START] 주문화면 CX 개선 이전(레거시) 로그 #################################
################# 100% 전환 이후에도 inactive 하지 않는 로그 ##################
        */
    export interface Impression {
      productOptions: GlobalStayProductOptions
      /*노출 UI 명칭. 노출 로그에서만 전송*/
      imprName?: string
      /*클릭 UI 명칭. 클릭 로그에서만 전송*/
      clickName?: string
    }
  }
  export namespace PointTypeCheckboxSave {
    /**
     * cartOrder 로그번호 : 470
     */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*체크 여부를 의미함.*/
      checkYn?: boolean
      /*클릭에 쓰인 내용. eg.연결하기, 전액사용, 삭제하기(=X버튼)*/
      clickName?: string
      /*놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace PointTypeCheckboxCheckYn {
    /**
     * cartOrder 로그번호 : 471
     */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*체크 여부를 의미함.*/
      checkYn?: boolean
      /*클릭에 쓰인 내용. eg.연결하기, 전액사용, 삭제하기(=X버튼)*/
      clickName?: string
      /*놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace PointTypeButtonClickName {
    /**
     * cartOrder 로그번호 : 472
     */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*체크 여부를 의미함.*/
      checkYn?: boolean
      /*클릭에 쓰인 내용. eg.연결하기, 전액사용, 삭제하기(=X버튼)*/
      clickName?: string
      /*놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace FreeCancelBoxCard {
    /**
        * 스크린샷: https://screen.yanolja.in/DorAhThYFoXYTKwU.png
해당 로그는 주문창 진입시점 내 최초 1회만 로그를 남김.
        */
    export interface Impression {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxCheckboxBtn {
    /**
     * 스크린샷: https://screen.yanolja.in/DorAhThYFoXYTKwU.png
     */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxButtonDetailBtn {
    /**
     * 스크린샷: https://screen.yanolja.in/DorAhThYFoXYTKwU.png
     */
    export interface Click {}
  }
  export namespace PopupFreeCancelLoginPopUp {
    /**
     * 스크린샷: https://screen.yanolja.in/pjcy7rQAcVjEPs4p.png
     */
    export interface Impression {}
  }
  export namespace FreeCancelLoginPopUpButtonBtn {
    /**
     * 스크린샷: https://screen.yanolja.in/pjcy7rQAcVjEPs4p.png
     */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FloatingButtonFreeCancelNudgeBtn {
    /**
     * 스크린샷: https://screen.yanolja.in/Dox0MK0ApIKIrm6i
     */
    export interface Click {}
  }
  export namespace TermsSectionCheckboxClickName {
    /**
        * ################# 100% 전환 이후 inactive 하는 로그 ##################
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      isLogin: boolean
      /*클릭한 약관 항목*/
      clickName: OrderTermsType
      /*클릭 후 해당 항목 체크 여부 (true: 체크, false: 해제)*/
      isChecked: boolean
    }
  }
  export namespace GlobalOrderView {
    /**
        * TODO: 주문창 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
################################ [END] 주문화면 CX 개선 이전(레거시) 로그 #################################
####################################################################################################
################################ [END] 주문창(GlobalOrder) 로그 #######################################
####################################################################################################
######################################################################################################
############################# [START] 주문완료/취소(GlobalOrderStatus) ##################################
######################################################################################################
################################ [START] 주문화면 CX 개선 로그 #################################
        */
    export interface View {
      /*체크인 일자.*/
      checkInDate: string
      /*체크아웃 일자.*/
      checkOutDate: string
      /*객실 정보.*/
      roomPeople?: RoomPeople[]
      /*숙소 id.*/
      propertyId: string
      /*객실 id.*/
      roomTypeId: string
      /*ratePlan id.*/
      ratePlanId: string
      /*사용 가능한 쿠폰수*/
      availableCouponCount: number
      /*총 가격.*/
      totalPrice: string
      /*객실 요금제 정보.
1. B2C 요금 &gt; B2C
2. B2B 요금 &gt; 회원 등급별로 다른 값(골드 회원 &gt; B2B / 항공구매 회원 &gt; FLIGHT / 골드체험 회원 &gt; B2B_TRAIL)
3. 뱃지 노출 여부 &gt; B2B 요금일 경우 노출되는 사실 활용*/
      priceType: string
      /*(구) 회원 등급 정보.*/
      globalStayPriceMemberCode: string
      /*취소정책 정보(CANNOT_REFUND-환불 불가/PARTIAL_REFUND-취소수수료 있음/FREE_CANCEL-무료취소)*/
      cancelBadgeType: CancelBadgeTypes
    }
  }
  export namespace PaymentNolMoneyButtonClickName {
    /**
     * 스크린샷 : https://screen.yanolja.in/HiNEfONERvx1KEhA
     */
    export interface Click {
      /*click_name : https://screen.yanolja.in/HiNEfONERvx1KEhA eg. 로그인, 충전계좌 등록 - 놀머니 가입, 계좌 등록*/
      clickName: string
      /*놀머니 가입 여부*/
      nolmoneyRegisterYn: string
      /*놀머니 계좌 연결 상태*/
      accountRegistrationYn: string
    }
  }
  export namespace PaymentNolMoneyPopupButtonClickName {
    /**
     * 스크린샷 : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69
     */
    export interface Click {
      /*click_name : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69 eg.계좌등록하기*/
      clickName: string
      /*놀머니 가입 여부*/
      nolmoneyRegisterYn: string
      /*놀머니 계좌 연결 상태*/
      accountRegistrationYn: string
    }
  }
  export namespace NolMoneyCertifyBottomSheetButton {
    /**
     * 화면 : https://screen.yanolja.in/NLsGOJuXf3Kr7lZH
     */
    export interface Click {}
  }
  export namespace SectionNameButtonClick {
    /**
     */
    export interface Click {
      /*놀머니브릿지페이지 바텀시트 클릭 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
모웹 앱안내 바텀시트 클릭 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
      /*버튼에 적혀있는 내용  eg.이어서 등록하기*/
      clickName: string
    }
  }
  export namespace BottomSheetSectionName {
    /**
     */
    export interface Impression {
      /*놀머니브릿지페이지 바텀시트 노출 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
놀머니 모웹 안내 바텀시트 노출 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
    }
  }
  export namespace SectionNamePopupClick {
    /**
     */
    export interface Click {
      /*놀머니브릿지페이지 바텀시트 클릭 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
모웹 앱안내 바텀시트 클릭 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
      /*버튼에 적혀있는 내용  eg.이어서 등록하기*/
      clickName: string
    }
  }
  export namespace PopupSectionName {
    /**
     */
    export interface Impression {
      /*놀머니브릿지페이지 바텀시트 노출 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
놀머니 모웹 안내 바텀시트 노출 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
    }
  }
  export namespace BottomSheetSectionName1137 {
    /**
     * NOL머니 계좌등록 이후 확인 가능
     */
    export interface Impression {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
    }
  }
  export namespace SectionNameButtonClick1138 {
    /**
     * NOL머니 계좌등록 이후 확인 가능
     */
    export interface Click {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      clickName: string
    }
  }
  export namespace PopupSectionName747 {
    /**
     */
    export interface Impression {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
    }
  }
  export namespace SectionNamePopupClick748 {
    /**
     * ######################### 현금 영수증 로그 ##########################
     */
    export interface Click {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      clickName: string
    }
  }
  export namespace WidgetCashReceipt {
    /**
     */
    export interface Impression {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptCheckbox {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptRadioType {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptDropdownFilter {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptTextFieldInput {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptSelectModalBottomSheetOptionName {
    /**
     */
    export interface Click {
      /*모달에서 선택한 항목 옵션*/
      optionName: CashReceiptOption
    }
  }
}



/**
* PageName: GLOBAL_ORDER_STATUS    */
export const GlobalOrderStatusPageLog = {
  BenefitInfoTextType: {
    /**
     * 주문완료/취소 - 노출 - 혜택 - 텍스트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L718}
     * GlobalStayOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L374}
     */
    impression({
      benefitType,
      benefitSubType,
      status,
    }: GlobalOrderStatusPageLog.BenefitInfoTextType.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1816,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_IMPR',
        benefitType,
        benefitSubType,
        status,
      })
    },

    /**
     * 주문완료/취소 - 클릭 - 혜택 - 텍스트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L734}
     * GlobalStayOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L374}
     */
    click({
      benefitType,
      benefitSubType,
      status,
    }: GlobalOrderStatusPageLog.BenefitInfoTextType.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1817,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
        benefitType,
        benefitSubType,
        status,
      })
    },
  },

  BenefitBannerId: {
    /**
     * 주문완료/취소 - 노출 - 베네핏배너 - 베너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L750}
     * GlobalStayOrderBenefitBanner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L404}
     */
    impression({
      benefitBannerId,
      benefitBannerTitle,
      status,
    }: GlobalOrderStatusPageLog.BenefitBannerId.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1818,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        benefitBannerId,
        benefitBannerTitle,
        status,
      })
    },

    /**
     * 주문완료/취소 - 클릭 - 베네핏배너 - 배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L766}
     * GlobalStayOrderBenefitBanner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L404}
     */
    click({
      benefitBannerId,
      benefitBannerTitle,
      status,
    }: GlobalOrderStatusPageLog.BenefitBannerId.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1819,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        benefitBannerId,
        benefitBannerTitle,
        status,
      })
    },
  },

  ButtonClose: {
    /**
     * 주문완료/취소 - 클릭 - 닫기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L782}
     */
    click({}: GlobalOrderStatusPageLog.ButtonClose.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        clientEventId: 1822,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'close',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  ButtonOrderDetail: {
    /**
     * 주문완료/취소 - 클릭 - 예약 상세보기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L795}
     */
    click({}: GlobalOrderStatusPageLog.ButtonOrderDetail.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1823,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'orderDetail',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  ButtonHome: {
    /**
        * 주문완료/취소 - 클릭 - 홈 - 버튼
        * ################################ [END] 주문화면 CX 개선 로그 #################################
################################ [START] 주문화면 CX 개선 이전(레거시) 로그 #################################
################# 100% 전환 이후에도 inactive 하지 않는 로그 ##################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L809}
                    */
    click({}: GlobalOrderStatusPageLog.ButtonHome.Click = {}) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1824,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'home',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  GlobalOrderStatusView: {
    /**
     * 주문완료/취소 - View - Page
     * 대기예약 : https://screen.yanolja.in/sjG2lPMF35sXjwLO.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L828}
     * GlobalOrderStatusView
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L96}
     */
    view({
      checkInDate,
      checkOutDate,
      roomPeople,
      propertyId,
      roomTypeId,
      ratePlanId,
      hashOrderId,
      couponId,
      purpose,
      status,
      gwPayType,
      orderAmount,
      gwPayAmount,
      couponAmount,
      usePoint,
      nolPointAmount,
      refundPgAmount,
      refundCouponAmount,
      refundPointAmount,
      refundNolPointAmount,
      maxDiscountYn,
      priceType,
      freeCancelAmount,
      refundFreeCancelAmount,
      cancelBadgeType,
    }: GlobalOrderStatusPageLog.GlobalOrderStatusView.View) {
      return KinesisTracker.view('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 74,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        eventType: 'EVENT_TYPE_VIEW',
        checkInDate,
        checkOutDate,
        roomPeople,
        propertyId,
        roomTypeId,
        ratePlanId,
        hashOrderId,
        couponId,
        purpose,
        status,
        gwPayType,
        orderAmount,
        gwPayAmount,
        couponAmount,
        usePoint,
        nolPointAmount,
        refundPgAmount,
        refundCouponAmount,
        refundPointAmount,
        refundNolPointAmount,
        maxDiscountYn,
        priceType,
        freeCancelAmount,
        refundFreeCancelAmount,
        cancelBadgeType,
      })
    },
  },

  BannerTripPlan: {
    /**
     * 주문완료 - 노출 - 여행일정 진입점 - 배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L840}
     * GlobalOrderStatusTripPlan
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L224}
     */
    impression({
      hashOrderId,
      status,
      tripId,
      title,
      subTitle,
      isNewTrip,
    }: GlobalOrderStatusPageLog.BannerTripPlan.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1429,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'tripPlan',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        status,
        tripId,
        title,
        subTitle,
        isNewTrip,
      })
    },

    /**
     * 주문완료 - 클릭 - 여행일정 진입점 - 배너
     * ################# [START] 100% 전환 이후 inactive 하는 로그 ##################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L852}
     * GlobalOrderStatusTripPlan
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L224}
     */
    click({
      hashOrderId,
      status,
      tripId,
      title,
      subTitle,
      isNewTrip,
    }: GlobalOrderStatusPageLog.BannerTripPlan.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1430,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'tripPlan',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        status,
        tripId,
        title,
        subTitle,
        isNewTrip,
      })
    },
  },

  FreeCancelBoxCard: {
    /**
     * 주문완료/취소 - 캔슬프리 카드 노출
     * TODO: 주문완료/취소 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L865}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    impression({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderStatusPageLog.FreeCancelBoxCard.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 75,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'freeCancelCard',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxButtonDetailBtn: {
    /**
     * 주문완료/취소 - 캔슬프리 상세보기 클릭
     * TODO: 주문완료/취소 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L881}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderStatusPageLog.FreeCancelBoxButtonDetailBtn.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 76,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'freeCancelDetailBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxButtonApplyBtn: {
    /**
        * 주문완료/취소 - 캔슬프리 환불 신청 하러가기 클릭
        * TODO: 주문완료/취소 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
해당 버튼은 status = STATUS_CANCELED 일 경우에만 나타남
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L897}
        * GlobalOrderFreeCancel
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
        */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderStatusPageLog.FreeCancelBoxButtonApplyBtn.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 77,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'freeCancelApplyBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FloatingButtonImprName: {
    /**
     * 주문완료 - 노출 - 여행일정 진입점 - 플로팅버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L913}
     * GlobalOrderFloatingButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L234}
     */
    impression({
      hashOrderId,
      status,
      imprName,
      clickName,
    }: GlobalOrderStatusPageLog.FloatingButtonImprName.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1431,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'imprName',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        status,
        imprName,
        clickName,
      })
    },
  },

  FloatingButtonClickName: {
    /**
        * 주문완료 - 클릭 - 여행일정 진입점 - 플로팅버튼
        * ################# [END] 100% 전환 이후 inactive 하는 로그 ##################
######################################################################################################
############################# [END] 주문완료/취소(GlobalOrderStatus) ##################################
######################################################################################################
################################### 주문상세(GOrderDetail) START ####################################
################################ [START] 주문상세 CX 개선 로그 #################################
# View
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L925}
        * GlobalOrderFloatingButton
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L234}
        */
    click({
      hashOrderId,
      status,
      imprName,
      clickName,
    }: GlobalOrderStatusPageLog.FloatingButtonClickName.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_STATUS', {
        inactive: false,
        clientEventId: 1432,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_STATUS',
        object: 'clickName',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        status,
        imprName,
        clickName,
      })
    },
  },
}

/**
* 자동생성된 로그 전송 타입
*/
export namespace GlobalOrderStatusPageLog {
  export namespace BenefitInfoTextType {
    /**
     */
    export interface Impression {
      /*https://screen.yanolja.in/saOSE9SnSVT6yezL
ex) nolCard | nolReview*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }

    /**
     */
    export interface Click {
      /*https://screen.yanolja.in/saOSE9SnSVT6yezL
ex) nolCard | nolReview*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }
  }
  export namespace BenefitBannerId {
    /**
     */
    export interface Impression {
      /*장바구니 베네핏배너 노출 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ
예약완료 베네핏배너 노출 : https://screen.yanolja.in/IaPM7qfcBnjMSefQ*/
      benefitBannerId: string
      /*배너타이틀*/
      benefitBannerTitle: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }

    /**
     */
    export interface Click {
      /*장바구니 베네핏배너 노출 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ
예약완료 베네핏배너 노출 : https://screen.yanolja.in/IaPM7qfcBnjMSefQ*/
      benefitBannerId: string
      /*배너타이틀*/
      benefitBannerTitle: string
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
    }
  }
  export namespace ButtonClose {
    /**
     */
    export interface Click {}
  }
  export namespace ButtonOrderDetail {
    /**
     */
    export interface Click {}
  }
  export namespace ButtonHome {
    /**
        * ################################ [END] 주문화면 CX 개선 로그 #################################
################################ [START] 주문화면 CX 개선 이전(레거시) 로그 #################################
################# 100% 전환 이후에도 inactive 하지 않는 로그 ##################
        */
    export interface Click {}
  }
  export namespace GlobalOrderStatusView {
    /**
     * 대기예약 : https://screen.yanolja.in/sjG2lPMF35sXjwLO.png
     */
    export interface View {
      /*체크인 일자.*/
      checkInDate: string
      /*체크아웃 일자.*/
      checkOutDate: string
      /*객실 정보.*/
      roomPeople?: RoomPeople[]
      /*결제방식. (PG or PG+Point 결제 시에는 paymentMethod 적재(e.g. KAKAOPAY). 단, 포인트 전액 결제 시에는 POINT로 적재)
숙소 id.*/
      propertyId: string
      /*객실 id.*/
      roomTypeId: string
      /*ratePlan id.*/
      ratePlanId: string
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*주문에 사용되는 쿠폰 식별자. couponUserId or couponInstanceId*/
      couponId?: string
      /*front 화면 진입 구분. ex) reservation, cancel  (이때, purpose+status를 조합하여 예약/취소 성공여부를 결정)*/
      purpose: GlobalOrderPurpose
      /*주문 API 응답 결과. ex) RESERVED, CANCELED*/
      status: GlobalOrderStatus
      /*결제방식.*/
      gwPayType: string
      /*노출된 판매가.*/
      orderAmount: string
      /*PG 결제금액.*/
      gwPayAmount: string
      /*쿠폰 사용금액.*/
      couponAmount?: string
      /*포인트 결제금액.*/
      usePoint?: string
      /*NOL 포인트 사용금액.*/
      nolPointAmount?: string
      /*PG 환불금액.*/
      refundPgAmount?: string
      /*쿠폰 환불금액.*/
      refundCouponAmount?: string
      /*포인트 환불금액.*/
      refundPointAmount?: string
      /*NOL 포인트 환불금액.*/
      refundNolPointAmount?: string
      /*주문서 &#39;최대 할인 적용&#39; 여부.*/
      maxDiscountYn?: YN
      /*객실 요금제 정보.
1. B2C 요금 &gt; B2C
2. B2B 요금 &gt; 회원 등급별로 다른 값(골드 회원 &gt; B2B / 항공구매 회원 &gt; FLIGHT / 골드체험 회원 &gt; B2B_TRAIL)
3. 뱃지 노출 여부 &gt; B2B 요금일 경우 노출됨*/
      priceType: string
      /*환불 안심케어(무료취소) 금액. 0원일 시 0으로 남김.*/
      freeCancelAmount: string
      /*환불 안심케어(무료취소) 환불금액. 0원일 시 0으로 남김.*/
      refundFreeCancelAmount?: string
      /*취소정책 정보(CANNOT_REFUND-환불 불가/PARTIAL_REFUND-취소수수료 있음/FREE_CANCEL-무료취소)*/
      cancelBadgeType: CancelBadgeTypes
    }
  }
  export namespace BannerTripPlan {
    /**
     */
    export interface Impression {
      hashOrderId: string
      /*주문 상태*/
      status: GlobalOrderStatus
      /*참고 샘플 https://screen.yanolja.in/XWmwAxl5Qhmk75t8*/
      tripId: string
      title: string
      subTitle: string
      /*신규 생성 일정 여부*/
      isNewTrip: boolean
    }

    /**
     * ################# [START] 100% 전환 이후 inactive 하는 로그 ##################
     */
    export interface Click {
      hashOrderId: string
      /*주문 상태*/
      status: GlobalOrderStatus
      /*참고 샘플 https://screen.yanolja.in/XWmwAxl5Qhmk75t8*/
      tripId: string
      title: string
      subTitle: string
      /*신규 생성 일정 여부*/
      isNewTrip: boolean
    }
  }
  export namespace FreeCancelBoxCard {
    /**
     * TODO: 주문완료/취소 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     */
    export interface Impression {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxButtonDetailBtn {
    /**
     * TODO: 주문완료/취소 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxButtonApplyBtn {
    /**
        * TODO: 주문완료/취소 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
해당 버튼은 status = STATUS_CANCELED 일 경우에만 나타남
        */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FloatingButtonImprName {
    /**
     */
    export interface Impression {
      hashOrderId: string
      /*주문 상태*/
      status: GlobalOrderStatus
      /*플로팅버튼 스크린샷 https://screen.yanolja.in/rzBajsTFoNChwPO2*/
      imprName?: string
      /*클릭 문구*/
      clickName?: string
    }
  }
  export namespace FloatingButtonClickName {
    /**
        * ################# [END] 100% 전환 이후 inactive 하는 로그 ##################
######################################################################################################
############################# [END] 주문완료/취소(GlobalOrderStatus) ##################################
######################################################################################################
################################### 주문상세(GOrderDetail) START ####################################
################################ [START] 주문상세 CX 개선 로그 #################################
# View
        */
    export interface Click {
      hashOrderId: string
      /*주문 상태*/
      status: GlobalOrderStatus
      /*플로팅버튼 스크린샷 https://screen.yanolja.in/rzBajsTFoNChwPO2*/
      imprName?: string
      /*클릭 문구*/
      clickName?: string
    }
  }
}



/**
* PageName: G_ORDER_DETAIL    */
export const GOrderDetailPageLog = {
  GOrderDetailViewV2: {
    /**
        * 해외숙소 - 주문상세(OrderDetail) - 페이지 View 로그
        * 혜택/레이트플랜 뱃지 수집을 위해 GOrderDetailViewV2 사용
# 버튼 클릭 - 전체
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L949}
        * GOrderDetailViewV2
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L167}
        */
    view({
      hashOrderId,
      status,
      cancelBadgeType,
      warrantyPolicyStatusCode,
      checkInDate,
      checkOutDate,
      roomPeople,
      propertyId,
      roomTypeId,
      ratePlanId,
      benefitBadges,
      ratePlanBadges,
    }: GOrderDetailPageLog.GOrderDetailViewV2.View) {
      return KinesisTracker.view('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 2317,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        eventType: 'EVENT_TYPE_VIEW',
        hashOrderId,
        status,
        cancelBadgeType,
        warrantyPolicyStatusCode,
        checkInDate,
        checkOutDate,
        roomPeople,
        propertyId,
        roomTypeId,
        ratePlanId,
        benefitBadges,
        ratePlanBadges,
      })
    },
  },

  ButtonClickName: {
    /**
     * 해외숙소 - 주문상세(OrderDetail) - 페이지 내 각종 버튼 클릭
     * # 버튼 클릭 - 캔슬프리 바텀싯
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L963}
     * GOrderDetailPageClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L543}
     */
    click({
      hashOrderId,
      status,
      cancelBadgeType,
      warrantyPolicyStatusCode,
      clickName,
    }: GOrderDetailPageLog.ButtonClickName.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 2303,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'clickName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        status,
        cancelBadgeType,
        warrantyPolicyStatusCode,
        clickName,
      })
    },
  },

  FreeCancelBottomSheetButtonClickName: {
    /**
     * 해외숙소 - 주문상세(OrderDetail) - 캔슬프리 바텀시트 내 버튼 클릭
     * # 버튼 클릭 - 예약확인서
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L980}
     * GOrderDetailFreeCancelSheetClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L589}
     */
    click({
      hashOrderId,
      status,
      cancelBadgeType,
      warrantyPolicyStatusCode,
      clickName,
    }: GOrderDetailPageLog.FreeCancelBottomSheetButtonClickName.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 2304,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'clickName',
        objectContainer: 'freeCancelBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        status,
        cancelBadgeType,
        warrantyPolicyStatusCode,
        clickName,
      })
    },
  },

  ReservationConfirmButtonClickName: {
    /**
        * 해외숙소 - 주문상세(OrderDetail) - 예약확인서 팝업 내 버튼 클릭
        * ################################ [END] 주문상세 CX 개선 로그 #################################
################################ [START] 주문상세 CX 개선 이전(레거시) 로그 #################################
################# 100% 전환 이후에도 inactive 하지 않는 로그 ##################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L998}
        * GOrderDetailReservationConfirmClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L597}
        */
    click({
      hashOrderId,
      status,
      cancelBadgeType,
      warrantyPolicyStatusCode,
      clickName,
    }: GOrderDetailPageLog.ReservationConfirmButtonClickName.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 2319,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'clickName',
        objectContainer: 'reservationConfirm',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        status,
        cancelBadgeType,
        warrantyPolicyStatusCode,
        clickName,
      })
    },
  },

  ButtonReservationConfirm: {
    /**
     * 해외숙소 - 주문상세(OrderDetail) - 메일로 예약확인서 보내기 - 클릭 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1023}
     * GOrderDetailClickNonRefundBtn
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L198}
     */
    click({ hashOrderId }: GOrderDetailPageLog.ButtonReservationConfirm.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 2320,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'reservationConfirm',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
      })
    },
  },

  ReservationConfirmButtonSend: {
    /**
     * 해외숙소 - 주문상세(OrderDetail) - 예약확인서 보내기 내 전송하기 - 클릭 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1039}
     * GOrderDetailClickNonRefundBtn
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L198}
     */
    click({ hashOrderId }: GOrderDetailPageLog.ReservationConfirmButtonSend.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 2321,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'send',
        objectContainer: 'reservationConfirm',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
      })
    },
  },

  ButtonPropertyId: {
    /**
     * 해외숙소 - 주문상세(OrderDetail) - 예약 숙소 확인하기(PDP 이동) - 클릭 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1055}
     * GOrderDetailClickNonRefundBtn
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L198}
     */
    click({ hashOrderId }: GOrderDetailPageLog.ButtonPropertyId.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 2322,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'propertyId',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
      })
    },
  },

  GOrderDetailView: {
    /**
     * 주문상세 - view 로그
     * 스크린샷: https://screen.yanolja.in/rd3pnFExh0bnLS4D.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1070}
     * GOrderDetailView
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L166}
     */
    view({
      checkInDate,
      checkOutDate,
      roomPeople,
      propertyId,
      roomTypeId,
      ratePlanId,
      hashOrderId,
      priceType,
      cancelBadgeType,
    }: GOrderDetailPageLog.GOrderDetailView.View) {
      return KinesisTracker.view('G_ORDER_DETAIL', {
        clientEventId: 78,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        eventType: 'EVENT_TYPE_VIEW',
        checkInDate,
        checkOutDate,
        roomPeople,
        propertyId,
        roomTypeId,
        ratePlanId,
        hashOrderId,
        priceType,
        cancelBadgeType,
      })
    },
  },

  PopupNonRefundBtn: {
    /**
        * 예약상세(해외숙소) - 예약취소 confirm > 예약 취소 버튼 클릭 로그
        * 스크린 샷: https://screen.yanolja.in/LERqhWsz69Rdpyhb.png
환불 불가인 경우에만 노출되는 confirm 팝업
################# 100% 전환 이후 inactive 하는 로그 ##################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1081}
        * GOrderDetailClickNonRefundBtn
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L198}
        */
    click({ hashOrderId }: GOrderDetailPageLog.PopupNonRefundBtn.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        clientEventId: 82,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'nonRefundBtn',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
      })
    },
  },

  FreeCancelBoxCard: {
    /**
     * 주문상세 - 캔슬프리 카드 노출
     * TODO: 예약상세 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1096}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    impression({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GOrderDetailPageLog.FreeCancelBoxCard.Impression) {
      return KinesisTracker.impression('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 79,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'freeCancelCard',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxButtonDetailBtn: {
    /**
     * 주문상세 - 캔슬프리 상세보기 클릭
     * TODO: 예약상세 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1112}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GOrderDetailPageLog.FreeCancelBoxButtonDetailBtn.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 80,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'freeCancelDetailBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxButtonApplyBtn: {
    /**
        * 주문상세 - 캔슬프리 환불 신청 하러가기 클릭
        * TODO: 예약상세 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
################################ [END] 주문상세 CX 개선 이전(레거시) 로그 #################################
################################### 주문상세(GOrderDetail) END ####################################
################################### 주문취소(GlobalOrderCancel) START ####################################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1128}
        * GlobalOrderFreeCancel
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
        */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GOrderDetailPageLog.FreeCancelBoxButtonApplyBtn.Click) {
      return KinesisTracker.click('G_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 81,
        pageName: 'PAGE_NAME_G_ORDER_DETAIL',
        object: 'freeCancelApplyBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },
}

/**
* 자동생성된 로그 전송 타입
*/
export namespace GOrderDetailPageLog {
  export namespace GOrderDetailViewV2 {
    /**
        * 혜택/레이트플랜 뱃지 수집을 위해 GOrderDetailViewV2 사용
# 버튼 클릭 - 전체
        */
    export interface View {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*주문 상태.*/
      status: GlobalOrderStatus
      /*취소정책 정보.*/
      cancelBadgeType: CancelBadgeTypes
      /*캔슬프리 상태 코드.*/
      warrantyPolicyStatusCode: WarrantyPolicyResultCode
      /*체크인 일자.*/
      checkInDate: string
      /*체크아웃 일자.*/
      checkOutDate: string
      /*객실 정보.*/
      roomPeople?: RoomPeople[]
      /*숙소 id.*/
      propertyId: string
      /*객실 id.*/
      roomTypeId: string
      /*ratePlan id.*/
      ratePlanId: string
      /*혜택 뱃지 정보. 예: [NOL_PICK, GOLD_CLASS], 뱃지 미노출시 [].*/
      benefitBadges?: GOrderDetailBenefitBadge[]
      /*레이트플랜 뱃지 정보. 노출정보 그대로 string 으로 입력받음. CS 차원에서 정확한 노출값을 string 으로 입력받음.
https://screen.yanolja.in/HzUM9h79oMmKvyfs.png
예: [킹배드 1개, 조식포함(2인 아침식사)]*/
      ratePlanBadges?: string[]
    }
  }
  export namespace ButtonClickName {
    /**
     * # 버튼 클릭 - 캔슬프리 바텀싯
     */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*주문 상태.*/
      status: GlobalOrderStatus
      /*취소정책 정보.*/
      cancelBadgeType: CancelBadgeTypes
      /*캔슬프리 상태 코드.*/
      warrantyPolicyStatusCode: WarrantyPolicyResultCode
      /*클릭 UI 명칭.*/
      clickName: GOrderDetailPageClickName
    }
  }
  export namespace FreeCancelBottomSheetButtonClickName {
    /**
     * # 버튼 클릭 - 예약확인서
     */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*주문 상태.*/
      status: GlobalOrderStatus
      /*취소정책 정보.*/
      cancelBadgeType: CancelBadgeTypes
      /*캔슬프리 상태 코드.*/
      warrantyPolicyStatusCode: WarrantyPolicyResultCode
      /*클릭 UI 명칭.*/
      clickName: GOrderDetailFreeCancelSheetClickName
    }
  }
  export namespace ReservationConfirmButtonClickName {
    /**
        * ################################ [END] 주문상세 CX 개선 로그 #################################
################################ [START] 주문상세 CX 개선 이전(레거시) 로그 #################################
################# 100% 전환 이후에도 inactive 하지 않는 로그 ##################
        */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*주문 상태.*/
      status: GlobalOrderStatus
      /*취소정책 정보.*/
      cancelBadgeType: CancelBadgeTypes
      /*캔슬프리 상태 코드.*/
      warrantyPolicyStatusCode: WarrantyPolicyResultCode
      /*클릭 UI 명칭.*/
      clickName: GOrderDetailReservationConfirmClickName
    }
  }
  export namespace ButtonReservationConfirm {
    /**
     */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
    }
  }
  export namespace ReservationConfirmButtonSend {
    /**
     */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
    }
  }
  export namespace ButtonPropertyId {
    /**
     */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
    }
  }
  export namespace GOrderDetailView {
    /**
     * 스크린샷: https://screen.yanolja.in/rd3pnFExh0bnLS4D.png
     */
    export interface View {
      /*체크인 일자.*/
      checkInDate: string
      /*체크아웃 일자.*/
      checkOutDate: string
      /*객실 정보.*/
      roomPeople?: RoomPeople[]
      /*숙소 id.*/
      propertyId: string
      /*객실 id.*/
      roomTypeId: string
      /*ratePlan id.*/
      ratePlanId: string
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*객실 요금제 정보.
1. B2C 요금 &gt; B2C
2. B2B 요금 &gt; 회원 등급별로 다른 값(골드 회원 &gt; B2B / 항공구매 회원 &gt; FLIGHT / 골드체험 회원 &gt; B2B_TRAIL)
3. 뱃지 노출 여부 &gt; B2B 요금일 경우 노출됨*/
      priceType: string
      /*취소정책 정보(CANNOT_REFUND-환불 불가/PARTIAL_REFUND-취소수수료 있음/FREE_CANCEL-무료취소)*/
      cancelBadgeType: CancelBadgeTypes
    }
  }
  export namespace PopupNonRefundBtn {
    /**
        * 스크린 샷: https://screen.yanolja.in/LERqhWsz69Rdpyhb.png
환불 불가인 경우에만 노출되는 confirm 팝업
################# 100% 전환 이후 inactive 하는 로그 ##################
        */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
    }
  }
  export namespace FreeCancelBoxCard {
    /**
     * TODO: 예약상세 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     */
    export interface Impression {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxButtonDetailBtn {
    /**
     * TODO: 예약상세 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
     */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxButtonApplyBtn {
    /**
        * TODO: 예약상세 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
################################ [END] 주문상세 CX 개선 이전(레거시) 로그 #################################
################################### 주문상세(GOrderDetail) END ####################################
################################### 주문취소(GlobalOrderCancel) START ####################################
        */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
}



/**
* PageName: GLOBAL_ORDER_CANCEL    */
export const GlobalOrderCancelPageLog = {
  FreeCancelBoxCard: {
    /**
     * 주문취소 - 캔슬프리 카드 노출
     * 스크린샷: https://screen.yanolja.in/RN0M5XTolw0AJSaf.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1152}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    impression({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderCancelPageLog.FreeCancelBoxCard.Impression) {
      return KinesisTracker.impression('GLOBAL_ORDER_CANCEL', {
        clientEventId: 83,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_CANCEL',
        object: 'freeCancelCard',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxButtonDetailBtn: {
    /**
     * 주문취소 - 캔슬프리 상세보기 클릭
     * 스크린샷: https://screen.yanolja.in/RN0M5XTolw0AJSaf.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1167}
     * GlobalOrderFreeCancel
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
     */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderCancelPageLog.FreeCancelBoxButtonDetailBtn.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_CANCEL', {
        clientEventId: 84,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_CANCEL',
        object: 'freeCancelDetailBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },

  FreeCancelBoxButtonDetailContentsBtn: {
    /**
        * 주문취소 - 캔슬프리 상세내용 클릭
        * 스크린샷: https://screen.yanolja.in/RN0M5XTolw0AJSaf.png
################################### 주문취소(GlobalOrderCancel) END ####################################
################################### 예약내역(GOrderList) START ####################################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1182}
        * GlobalOrderFreeCancel
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L85}
        */
    click({
      freeCancelPrice,
      status,
      warrantyPolicyStatusCode,
    }: GlobalOrderCancelPageLog.FreeCancelBoxButtonDetailContentsBtn.Click) {
      return KinesisTracker.click('GLOBAL_ORDER_CANCEL', {
        clientEventId: 85,
        pageName: 'PAGE_NAME_GLOBAL_ORDER_CANCEL',
        object: 'freeCancelDetailContentsBtn',
        objectContainer: 'freeCancelBox',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        freeCancelPrice,
        status,
        warrantyPolicyStatusCode,
      })
    },
  },
}

/**
* 자동생성된 로그 전송 타입
*/
export namespace GlobalOrderCancelPageLog {
  export namespace FreeCancelBoxCard {
    /**
     * 스크린샷: https://screen.yanolja.in/RN0M5XTolw0AJSaf.png
     */
    export interface Impression {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxButtonDetailBtn {
    /**
     * 스크린샷: https://screen.yanolja.in/RN0M5XTolw0AJSaf.png
     */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
  export namespace FreeCancelBoxButtonDetailContentsBtn {
    /**
        * 스크린샷: https://screen.yanolja.in/RN0M5XTolw0AJSaf.png
################################### 주문취소(GlobalOrderCancel) END ####################################
################################### 예약내역(GOrderList) START ####################################
        */
    export interface Click {
      /*환불 안심케어 가격. 유료: 유료 가격 / 쿠폰: 0 / 로그인 필요: NULL*/
      freeCancelPrice?: number
      /*주문 API 응답 결과(ex. RESERVED, CANCELED). 주문 상태창(GlobalOrderStatus) 화면에서만 해당 값을 남기고 그 외 화면에서는 남기지 않음.*/
      status?: GlobalOrderStatus
      /*캔슬프리 상태 코드. 주문창에서는 해당 값이 존재하지 않음
상세 정보는 https://yanolja.atlassian.net/wiki/spaces/PF/pages/395578309/2024-08-02#%EC%83%81%ED%83%9C%EB%B3%84-%EC%BD%94%EB%93%9C-%EA%B5%AC%EB%B6%84 참고.*/
      warrantyPolicyStatusCode?: WarrantyPolicyResultCode
    }
  }
}



/**
* PageName: G_ORDER_LIST    */
export const GOrderListPageLog = {
  PopupNonRefundBtn: {
    /**
        * 예약내역 - 예약취소 confirm > 예약 취소 버튼 클릭 로그
        * TODO: 예약내역 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
환불 불가인 경우에만 노출되는 confirm 팝업
################################ [START] 예약내역(OrderList) CX 개선 로그 #################################
# description : 도메인 - 페이지 - 설명 구조로 통일
# View
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1203}
        * GOrderListClickNonRefundBtn
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L193}
        */
    click({ hashOrderId }: GOrderListPageLog.PopupNonRefundBtn.Click) {
      return KinesisTracker.click('G_ORDER_LIST', {
        inactive: false,
        clientEventId: 86,
        pageName: 'PAGE_NAME_G_ORDER_LIST',
        object: 'nonRefundBtn',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
      })
    },
  },

  GOrderListView: {
    /**
     * 해외숙소 - 예약내역(OrderList) - 페이지 View 로그
     * # 예약상품 카드 노출/클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1223}
     * GOrderListView
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L481}
     */
    view({ tabName }: GOrderListPageLog.GOrderListView.View) {
      return KinesisTracker.view('G_ORDER_LIST', {
        inactive: false,
        clientEventId: 2264,
        pageName: 'PAGE_NAME_G_ORDER_LIST',
        eventType: 'EVENT_TYPE_VIEW',
        tabName,
      })
    },
  },

  StatusTabCardHashOrderId: {
    /**
        * 해외숙소 - 예약내역(OrderList) - 페이지 내 예약상품 노출
        * # Click
# 본래 object_type = button 이나, 중요 Click event 임을 고려하여 card 로 변경하여 Tracking.
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1237}
        * GOrderListReservationCard
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L487}
        */
    impression({
      hashOrderId,
      propertyId,
      checkInDate,
      checkOutDate,
      position,
      cancelBadgeType,
      cardStatus,
      tabName,
    }: GOrderListPageLog.StatusTabCardHashOrderId.Impression) {
      return KinesisTracker.impression('G_ORDER_LIST', {
        inactive: false,
        clientEventId: 2265,
        pageName: 'PAGE_NAME_G_ORDER_LIST',
        object: 'hashOrderId',
        objectContainer: 'statusTab',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        propertyId,
        checkInDate,
        checkOutDate,
        position,
        cancelBadgeType,
        cardStatus,
        tabName,
      })
    },

    /**
     * 해외숙소 - 예약내역(OrderList) - 페이지 내 예약상품(>) 클릭
     * # 배너 노출/클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1256}
     * GOrderListReservationCard
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L487}
     */
    click({
      hashOrderId,
      propertyId,
      checkInDate,
      checkOutDate,
      position,
      cancelBadgeType,
      cardStatus,
      tabName,
    }: GOrderListPageLog.StatusTabCardHashOrderId.Click) {
      return KinesisTracker.click('G_ORDER_LIST', {
        inactive: false,
        clientEventId: 2266,
        pageName: 'PAGE_NAME_G_ORDER_LIST',
        object: 'hashOrderId',
        objectContainer: 'statusTab',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        propertyId,
        checkInDate,
        checkOutDate,
        position,
        cancelBadgeType,
        cardStatus,
        tabName,
      })
    },
  },

  StatusTabBannerId: {
    /**
     * 해외숙소 - 예약내역(OrderList) - 페이지 내 배너 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1274}
     * GOrderListBanner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L509}
     */
    impression({ bannerId, bannerTitle }: GOrderListPageLog.StatusTabBannerId.Impression) {
      return KinesisTracker.impression('G_ORDER_LIST', {
        inactive: false,
        clientEventId: 2267,
        pageName: 'PAGE_NAME_G_ORDER_LIST',
        object: 'bannerId',
        objectContainer: 'statusTab',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        bannerId,
        bannerTitle,
      })
    },

    /**
        * 해외숙소 - 예약내역(OrderList) - 페이지 내 배너 클릭
        * # 기타 각종 버튼
# 중요하지 않은 버튼이므로, object_container는 정의하지 않음
# 탭 이동은 분석하지 않아, 해당 로그는 수집하지 않기로 합의
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1291}
        * GOrderListBanner
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L509}
        */
    click({ bannerId, bannerTitle }: GOrderListPageLog.StatusTabBannerId.Click) {
      return KinesisTracker.click('G_ORDER_LIST', {
        inactive: false,
        clientEventId: 2268,
        pageName: 'PAGE_NAME_G_ORDER_LIST',
        object: 'bannerId',
        objectContainer: 'statusTab',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        bannerId,
        bannerTitle,
      })
    },
  },

  ButtonClickName: {
    /**
        * 해외숙소 - 예약내역(OrderList) - 페이지 내 (각종) 버튼 클릭
        * ################################ [END] 예약내역 CX 개선 로그 #################################
################################### 예약내역(GOrderList) END ####################################
################################### inactive 로그 START ####################################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1311}
        * GOrderListOtherButtonClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/accommodations_abroad.proto#L517}
        */
    click({ clickName, tabName }: GOrderListPageLog.ButtonClickName.Click) {
      return KinesisTracker.click('G_ORDER_LIST', {
        inactive: false,
        clientEventId: 2269,
        pageName: 'PAGE_NAME_G_ORDER_LIST',
        object: 'clickName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        clickName,
        tabName,
      })
    },
  },
}

/**
* 자동생성된 로그 전송 타입
*/
export namespace GOrderListPageLog {
  export namespace PopupNonRefundBtn {
    /**
        * TODO: 예약내역 레거시 UI 100% 전환 완료 이후 inactive: true 로 변경
환불 불가인 경우에만 노출되는 confirm 팝업
################################ [START] 예약내역(OrderList) CX 개선 로그 #################################
# description : 도메인 - 페이지 - 설명 구조로 통일
# View
        */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
    }
  }
  export namespace GOrderListView {
    /**
     * # 예약상품 카드 노출/클릭
     */
    export interface View {
      /*선택된 탭 정보.*/
      tabName: GOrderListStatus
    }
  }
  export namespace StatusTabCardHashOrderId {
    /**
        * # Click
# 본래 object_type = button 이나, 중요 Click event 임을 고려하여 card 로 변경하여 Tracking.
        */
    export interface Impression {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*숙소 id.*/
      propertyId: string
      /*체크인 일자. format: yyyy-MM-dd*/
      checkInDate: string
      /*체크아웃 일자. format: yyyy-MM-dd*/
      checkOutDate: string
      /*리스트 내 카드 노출 순서(0부터 시작).*/
      position: number
      /*취소정책 뱃지 정보(https://screen.yanolja.in/fuU32PjwsnyN5g5Z.png)*/
      cancelBadgeType: CancelBadgeTypes
      /*카드상태와 선택된 탭 정보는 상이 &gt; 분리하여 정의
예약카드 상태(https://screen.yanolja.in/fuU32PjwsnyN5g5Z.png).*/
      cardStatus: GOrderListStatus
      /*예약카드 노출,클릭시 선택된 탭.*/
      tabName: GOrderListStatus
    }

    /**
     * # 배너 노출/클릭
     */
    export interface Click {
      /*해싱처리된 주문 id.*/
      hashOrderId: string
      /*숙소 id.*/
      propertyId: string
      /*체크인 일자. format: yyyy-MM-dd*/
      checkInDate: string
      /*체크아웃 일자. format: yyyy-MM-dd*/
      checkOutDate: string
      /*리스트 내 카드 노출 순서(0부터 시작).*/
      position: number
      /*취소정책 뱃지 정보(https://screen.yanolja.in/fuU32PjwsnyN5g5Z.png)*/
      cancelBadgeType: CancelBadgeTypes
      /*카드상태와 선택된 탭 정보는 상이 &gt; 분리하여 정의
예약카드 상태(https://screen.yanolja.in/fuU32PjwsnyN5g5Z.png).*/
      cardStatus: GOrderListStatus
      /*예약카드 노출,클릭시 선택된 탭.*/
      tabName: GOrderListStatus
    }
  }
  export namespace StatusTabBannerId {
    /**
     */
    export interface Impression {
      /*배너 아이디.*/
      bannerId: string
      /*배너 타이틀.*/
      bannerTitle: string
    }

    /**
        * # 기타 각종 버튼
# 중요하지 않은 버튼이므로, object_container는 정의하지 않음
# 탭 이동은 분석하지 않아, 해당 로그는 수집하지 않기로 합의
        */
    export interface Click {
      /*배너 아이디.*/
      bannerId: string
      /*배너 타이틀.*/
      bannerTitle: string
    }
  }
  export namespace ButtonClickName {
    /**
        * ################################ [END] 예약내역 CX 개선 로그 #################################
################################### 예약내역(GOrderList) END ####################################
################################### inactive 로그 START ####################################
        */
    export interface Click {
      /*클릭 버튼 정보.*/
      clickName: GOrderListOtherClicks
      /*버튼 클릭시 선택된 탭 정보.*/
      tabName: GOrderListStatus
    }
  }
}



/**
* PageName: GLOBAL_PAYMENT    */
export const GlobalPaymentPageLog = {
  PopupSectionName: {
    /**
     * (해외숙소)결제 - 결제 중 화면닫기 시 confirm 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1647}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L180}
     */
    impression({ sectionName }: GlobalPaymentPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('GLOBAL_PAYMENT', {
        inactive: false,
        clientEventId: 745,
        pageName: 'PAGE_NAME_GLOBAL_PAYMENT',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
      })
    },
  },

  SectionNamePopupClick: {
    /**
     * (해외숙소)결제 - 결제 중 화면닫기 시 confirm 팝업 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/accommodations_abroad/common.txtpb#L1660}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L187}
     */
    click({ sectionName, clickName }: GlobalPaymentPageLog.SectionNamePopupClick.Click) {
      return KinesisTracker.click('GLOBAL_PAYMENT', {
        inactive: false,
        clientEventId: 746,
        pageName: 'PAGE_NAME_GLOBAL_PAYMENT',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
      })
    },
  },
}

/**
* 자동생성된 로그 전송 타입
*/
export namespace GlobalPaymentPageLog {
  export namespace PopupSectionName {
    /**
     */
    export interface Impression {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
    }
  }
  export namespace SectionNamePopupClick {
    /**
     */
    export interface Click {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      clickName: string
    }
  }
}
